<template>
  <div id="page-user-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="6">
        <h2 class="breadcrumb">Χρήστες</h2>
      </vs-col>
      <vs-col vs-w="6">
        <vs-button @click.prevent="createNewUser" color="primary" type="filled" icon="add"
                   class="ml-auto mb-2">
          Προσθήκη
        </vs-button>
      </vs-col>
    </vs-row>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div v-if="users.length" class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{
                                currentPage * paginationPageSize - (paginationPageSize - 1)
                              }} - {{
                                users.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : users.length
                              }} of {{ users.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="changeGridNoOfRows(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changeGridNoOfRows(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changeGridNoOfRows(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="changeGridNoOfRows(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                  v-model="searchQuery" @input="updateSearchQuery" placeholder="Αναζήτηση..."/>
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="users"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :paginationAutoPageSize="true"
          :filter="true"
          :resizable="true"
          :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="currentPage"/>

    </div>
  </div>

</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer
import CellRendererLink from './cell-renderer-users/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer-users/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer-users/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer-users/CellRendererActions.vue'

export default {
  components: {
    AgGridVue,
    flatPickr,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      initiated: false,
      modalTitle: '',
      popupActive: false,
      switch1: true,

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: "always",
        colResizeDefault: "shift",
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: 'agTextColumnFilter',
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          suppressNavigable: true,
          cellClass: 'no-border'

        },
        {
          headerName: 'Username',
          field: 'username',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border'

        },
        {
          headerName: 'Email',
          field: 'email',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border'
        },
        {
          headerName: 'Όνομα',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border'
        },
        {
          headerName: 'Επώνυμο',
          field: 'surname',
          filter: 'agTextColumnFilter',
          flex: 1,
          suppressNavigable: true,
          cellClass: 'no-border'
        },
        {
          headerName: 'Κατάσταση',
          field: 'isActive',
          filter: 'agTextColumnFilter',
          width: 150,
          cellRendererFramework: 'CellRendererStatus',
          suppressNavigable: true,
          cellClass: 'no-border'
        },
        {
          headerName: '',
          field: 'transactions',
          width: 80,
          filter: false,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          suppressNavigable: true,
          cellClass: 'no-border'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {},
  computed: {
    users() {
      return this.$store.getters.getUsers
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      }
    }
  },
  methods: {
    createNewUser() {
      this.$store.dispatch('displayUserPopUp', true)
      this.$store.dispatch('setUserPopUpTitle', 'Δημιουργία χρήστη')
      this.$store.dispatch('userSetter', {
        name: '',
        surname: '',
        username: '',
        email: '',
        password: '',
        role: '',
        isActive: false,
        sendMassiveEmail: false,
        sendOnlyChanges: false
      })
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: 'All',
        value: 'all'
      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addRecord(item) {
      let vm = this;
      // VALIDATION SECTION
      this.initiated = true;
      if (!vm.validateForm()) {
        vm.$vs.notify({
          color: 'danger',
          title: 'Λάθος στον έλέγχο πεδίων',
          position: 'top-right',
          text: 'Παρακαλώ συμπληρώστε όλα τα πεδία με *.'
        })
        if (item.password && item.password.length < 6) {
          vm.$vs.notify({
            color: 'warning',
            title: 'Λάθος στον έλέγχο πεδίων',
            position: 'top-right',
            text: 'Ο κωδικός πρέπει να είναι τουλάχιστον 6 χαρακτήρες.'
          })
        }
        return;
      }
      if (item.id) {
        this.$store.dispatch('editItem', item)
            .then(() => {
              vm.popupActive = false;
              vm.item = {};
              vm.initiated = false;
              vm.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.'
              })
              this.$store.dispatch('displayUserPopUp', false)
            })
            .catch(err => {
              vm.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.'
              })
              console.error(err);
            })
      } else {
        this.$store.dispatch('addItem', item)
            .then(() => {
              vm.popupActive = false;
              vm.item = {};
              vm.initiated = false;
              vm.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.'
              })
              this.$store.dispatch('displayUserPopUp', false)
            })
            .catch(err => {
              vm.$vs.notify({
                color: 'warning',
                title: 'User not saved',
                position: 'top-right',
                text: 'Username or email already exists'
              })

              console.error(err)
            })
      }
    },
    editRecord(item) {
      let vm = this;
      vm.popupActive = true;
      vm.item = item;
      vm.modalTitle = "Ενημέρωση Εγγραφής";
    },
    changeGridNoOfRows(rows) {
      this.gridApi.paginationAutoPageSize = false;
      this.gridApi.paginationSetPageSize(rows)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }

  },
  created() {
    this.$store.dispatch('fetchUsers')
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.ag-cell-focus, .ag-cell-no-focus {
  border: none !important;
}

/* This CSS is to not apply the border for the column having 'no-border' class */
.no-border.ag-cell:focus {
  border: none !important;
  outline: none;
}


</style>
